import { Floor } from '../../types';
import api from '../../utils/api';
import { omit } from 'lodash/fp';

export const updateFloor = (variables: Floor) =>
  api.put({
    url: `/floor/${variables.id}`,
    variables: omit(['id'], variables),
  });
